import * as React from "react";

import { DashboardAwardTypeModel } from "models/ApiModels";

import { TableRow, TableCell } from "@mui/material";

import MuiLink from "components/MuiExtras/MuiLink";

import { AwardType } from "models/ApiEnums";
import { WithTranslation, withTranslation } from "react-i18next";


interface IRenderAwardTypeModelListProps {
    indexOffset: number;
    items: DashboardAwardTypeModel[];
    onSelect?: (awardType: AwardType) => void;
    onDrillDown: (awardType: AwardType, name: string) => void;
}

type Props = IRenderAwardTypeModelListProps & WithTranslation;

class RenderAwardTypeModelList extends React.PureComponent<Props> {

    public render() {
        const { indexOffset, items, onDrillDown, onSelect } = this.props;

        return items.map((v, index) => {

            const reason = this.props.t(`AwardType.${AwardType[v.awardType]}`);

            return (
                <TableRow key={index}>
                    <TableCell style={{ width: 1 }}>{indexOffset + index + 1}</TableCell>

                    <TableCell>
                        {
                            onSelect
                                ? (
                                    <MuiLink
                                        color="secondary"
                                        onClick={() => onSelect(v.awardType)}
                                    >
                                        {reason}
                                    </MuiLink>
                                )
                                : <>{reason}</>
                        }
                    </TableCell>

                    {
                        v.total &&
                        <TableCell align="right">
                            <MuiLink
                                color="secondary"
                                onClick={() => onDrillDown(v.awardType, reason)}
                            >
                                {v.total.toLocaleString()}
                            </MuiLink>
                        </TableCell>
                    }
                </TableRow>
            );
        });
    }
}

export default withTranslation('sys')(RenderAwardTypeModelList);
